import { Injectable } from '@angular/core';

@Injectable()
export class GtLocalStorageService {

  public put(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  public value(key: string): string {
    return localStorage.getItem(key);
  }

  public remove(key: string): void {
    localStorage.removeItem(key);
  }

  public removeAll(): void {
    localStorage.clear();
  }
}
